import { useTranslation } from 'next-i18next'
import { createElement, useState } from 'react'

import { useSrpContext } from '@/contexts/SrpContext'
import { type ContentfulDataContent } from '@/types/contentful'
import { isBrowserSafari } from '@/utils/userAgent'

import {
  ContentfulContentContainer,
  ContentfulContentShowMoreLink,
  ContentfulContentStyled,
} from './styled'

export const ContentfulContent = ({ textJson }: { textJson: ContentfulDataContent | null }) => {
  const { t } = useTranslation('common')
  const { userAgent = '' } = useSrpContext()
  const [isShowingMore, setIsShowingMore] = useState<boolean>(false)

  const isSafari = isBrowserSafari(userAgent)

  if (!textJson) return null

  const innerContent = textJson.map(({ type, content }, index) => {
    if (!type) return null

    return createElement(type, {
      dangerouslySetInnerHTML: { __html: content },
      key: `ContentfulContent-${type}-${index}`,
    })
  })

  return (
    <ContentfulContentContainer isSafari={isSafari} isShowingMore={isShowingMore}>
      <ContentfulContentStyled
        isShowingMore={isShowingMore}
        isSafari={isSafari}
        key="ContentfulContent"
      >
        {innerContent}
      </ContentfulContentStyled>

      {isShowingMore || !isSafari ? '' : '...'}

      <ContentfulContentShowMoreLink
        $isShowingMore={isShowingMore}
        data-testid="contentful-content-show-link"
        hasUnderline
        onClick={() => setIsShowingMore(!isShowingMore)}
        variant="secondary"
      >
        {isShowingMore ? t('show.less') : t('read.more')}
      </ContentfulContentShowMoreLink>
    </ContentfulContentContainer>
  )
}
